import { render } from "./Whoweare.vue?vue&type=template&id=36ae3a07&scoped=true"
import script from "./Whoweare.vue?vue&type=script&lang=js"
export * from "./Whoweare.vue?vue&type=script&lang=js"

import "./Whoweare.vue?vue&type=style&index=0&id=36ae3a07&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ae3a07"]])

export default __exports__